import { HttpStatusCode } from 'axios';
import { ApiRequest } from '../../Handlers/ApiReqest';
import { AccountsSheetItem } from '../../Models/Accounts';
import { InterActive } from '../../utilities/ViewModelStructure'
import * as XLSX from 'xlsx';
import { Notify } from '../../Handlers/Notifications';


export class AccountsSheetVM extends InterActive{
    private data:AccountsSheetItem[] = [];
    public get Data():AccountsSheetItem[]{ return this.data  }
    public set Data(value:AccountsSheetItem[]){ this.data = value ; this.update()  }

    private from:string = '';
    public get From():string{ return this.from  }
    public set From(value:string){ this.from = value ; this.update()  }

    private to:string = '';
    public get To():string{ return this.to  }
    public set To(value:string){ this.to = value ; this.update()  }

    public getData(){
        this.loading(
            async()=>{
                if(this.val()){
                    try{
                        const response = await ApiRequest.accountsSheet({from:this.from , to:this.to})
                        console.log(response)
                        if(response){
                            if(response.status === HttpStatusCode.Ok){
                                if(response.data.status){
                                    this.data = response.data.data

                                    this.update()
                                }else Notify({type:'danger' , title:'فشل عملية الازالة', body:response.data.messege})
                            }else Notify({type:'danger' , title:'فشل عملية الازالة', body:'فشل عملية الازالة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                        }
                    }catch{
                        Notify({type:'danger' , title:'فشل عملية الازالة', body:'فشل عملية الازالة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }
            }
        )
    }

    public val(){
        if(!this.from){  return false }
        if(!this.to){  return false }
        return true
    }

    public downloadExcel()  {
        const worksheet = XLSX.utils.json_to_sheet(
            this.data.map(item=>({
                'الحساب':item.account_name,
                'المبيعات الاساسية':item.main_value,
                'المدفوعات الاضافية':item.additional_value,
            }))
        )
        const workbook = XLSX.utils.book_new()

        XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
        XLSX.writeFile(workbook, 'accounts_from_'+this.from+'_to_'+this.to+'.xlsx');
      };
    
}